import { cdnUrl } from '@/config/cdn'

const imgPath = cdnUrl('website/')
let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
let couponQrcodeBaseUrl = 'https://www.taipuauto.com/'
let qrcodeTypeToPage = {
    coupon: 'couponapply?couponId='
}
export default
{
    imgPath,
    isMobile,
    couponQrcodeBaseUrl,
    qrcodeTypeToPage
}
